import { OrderHistoryActions } from '../actions/index';
// import { AccessRequestDetails } from '../access-request.state';
import { createReducer, on } from '@ngrx/store';
import { models } from 'powerbi-client';
import { OrderHistoryCharts } from '../order-history-state';


export const initialState: OrderHistoryCharts = {
    loading: null,
    success: null,
    error: null,
    sales: {
        type: 'report',
        embedUrl: '',
        tokenType: models.TokenType.Embed,
        accessToken: '',
        settings: {
            panes: {
                filters: {
                    visible: false,
                },
                pageNavigation: {
                    visible: false,
                },
            },
        },
    },

    soldSales: {
        type: 'report',
        embedUrl: '',
        tokenType: models.TokenType.Embed,
        accessToken: '',
        settings: {
            panes: {
                filters: {
                    visible: false,
                },
                pageNavigation: {
                    visible: false,
                },
            },
        },
    },
    customerWiseSales: {
        type: 'report',
        embedUrl: '',
        tokenType: models.TokenType.Embed,
        accessToken: '',
        settings: {
            panes: {
                filters: {
                    visible: false,
                },
                pageNavigation: {
                    visible: false,
                },
            },
        },
    },
    legalEntityWiseSales: {
        type: 'report',
        embedUrl: '',
        tokenType: models.TokenType.Embed,
        accessToken: '',
        settings: {
            panes: {
                filters: {
                    visible: false,
                },
                pageNavigation: {
                    visible: false,
                },
            },
        },
    }
};
// sales: {
//     type: 'report',
//     embedUrl: '',
//     tokenType: models.TokenType.Embed,
//     accessToken: '',
//     settings: {
//         panes: {
//             filters: {
//                 visible: false,
//             },
//             pageNavigation: {
//                 visible: false,
//             },
//         },
//     },
// },

export const orderHistoryChartsReducer = createReducer(
    initialState,
    on(OrderHistoryActions.loadSalesCharts, (state) => ({
        ...state,
        loading: true,
        success: null,
        error: null,
    })),
    on(OrderHistoryActions.loadSalesChartsSuccess, (state, { payload }) => {
        return {
            ...state,
            sales: payload,
            loading: null,
            success: true,
            error: null,
        };
    }),
    on(OrderHistoryActions.loadSalesChartsFailure, (state, { payload }) => ({
        ...state,
        loading: null,
        success: null,
        error: payload
    })),
    on(OrderHistoryActions.loadSoldSales, (state) => ({
        ...state,
        loading: true,
        success: null,
        error: null,
    })),
    on(OrderHistoryActions.loadSoldSalesSuccess, (state, { payload }) => {
        return {
            ...state,
            soldSales: payload,
            loading: null,
            success: true,
            error: null,
        };
    }),
    on(OrderHistoryActions.loadSoldSalesFailure, (state, { payload }) => ({
        ...state,
        loading: null,
        success: null,
        error: payload
    })),
    on(OrderHistoryActions.loadCustomerWiseSales, (state) => ({
        ...state,
        loading: true,
        success: null,
        error: null,
    })),
    on(OrderHistoryActions.loadCustomerWiseSalesSuccess, (state, { payload }) => {
        return {
            ...state,
            customerWiseSales: payload,
            loading: null,
            success: true,
            error: null,
        };
    }),
    on(OrderHistoryActions.loadCustomerWiseSalesFailure, (state, { payload }) => ({
        ...state,
        loading: null,
        success: null,
        error: payload
    })),
    on(OrderHistoryActions.loadLegalEntityWiseSales, (state) => ({
        ...state,
        loading: true,
        success: null,
        error: null,
    })),
    on(OrderHistoryActions.loadLegalEntityWiseSalesSuccess, (state, { payload }) => {
        return {
            ...state,
            legalEntityWiseSales: payload,
            loading: null,
            success: true,
            error: null,
        };
    }),
    on(OrderHistoryActions.loadLegalEntityWiseSalesFailure, (state, { payload }) => ({
        ...state,
        loading: null,
        success: null,
        error: payload
    })),
);